module.exports = __webpack_public_path__ + "static/img/product-swipe31.9c7f1cfb.png";